import {Form, InputNumber, Modal,  App,    Row, Col, DatePicker, Space   } from 'antd'
import React, { useEffect, useState } from 'react'
import classes from './loan.module.css'
import Icon from '../../cpn/Icon';
import { useJiekuanAddMutation, useJKaddtijiaoMutation } from '../../store/DianShangYeWuApi';
import OCRTextArea from '../../cpn/OCRTextArea';
import ClientSelect from '../../system/client/ClientSelect';  
import ClientBankSelect from '../../system/client/ClientBankSelect';
import UploadPic from '../../cpn/UploadPic';
import dayjs from 'dayjs';
import DocumentRule from '../../cpn/DocumentRule';
import Asterisk from '../../cpn/Asterisk';
import LoanNodeAdd from './LoanNodeAdd';
function LoanAddReportEdit(props) {
    const { message } = App.useApp();
    const [open,setOpen] = useState(false);
    const [info,setInfo] = useState({
        'jk_price': props.dsbzd_kh_id,//保存团队客户id
        'jk_uid': '',
        'jk_uname': '',
        'jk_content': '',
        'jk_bzd_id': '',
        'jk_qy_id': '',
        'jk_qy_name': '',
        'jk_kh_id': '',
        'jk_kh_name': '',
        'jk_type_id': props.dsbzd_dscp_id,//保存团队客户类型id
        'jk_type_name': props.dsbzd_dscp_name,//保存团队客户类型名称
        'jk_amount': '',
        'jk_bzd_xuhao': '',
        'jk_bzd_name': '',
        'jk_date': props.dsbzd_date ? dayjs(props.dsbzd_date) : undefined,
        'jk_bzd_date_end': '',
        'jk_num': props.dsbzd_kh_name,//保存团队客户名称
        'jk_name': '',
        'jk_bzd_date': '',
        'jk_khyhzh_id': '',
        'jk_khyhzh_name': '',
        'jk_image_name': '',
        'jk_image_file': '',
        'jk_bm_id': props.dsbzd_bm_id,
        'jk_bm_name': props.dsbzd_bm_name,
        'jk_state': '1',
        'jk_zflx': '应收'
    })
    const [form] = Form.useForm();
    const [add] = useJiekuanAddMutation();
    useEffect(() => {
        // 确保jk_date有默认值，同时更新其他相关字段
        if (!info.jk_date || props.dsbzd_date !== info.jk_date || props.dsbzd_date_end !== info.jk_date_end) {
            setInfo(prevState => ({
                ...prevState,
                jk_date: props.dsbzd_date || new Date().toISOString().split('T')[0],
                jk_date_end: props.dsbzd_date_end || new Date().toISOString().split('T')[0],
                jk_bzd_name: props.dsbzd_name || prevState.jk_bzd_name,
                jk_bzd_danhao: props.dsbzd_danhao || prevState.jk_bzd_danhao,
                jk_bzd_id: props.dsbzd_id || prevState.jk_bzd_id
            }))
        }
    }, [props, info.jk_date, info.jk_date_end])

    // 当Modal打开时设置表单值
    useEffect(() => {
        if (open) {
            if (props.dsbzd_date && props.dsbzd_date_end) {
                form.setFieldsValue({
                    jk_bzd_name: props.dsbzd_danhao + ' ' + props.dsbzd_name,
                })
            }
            // 设置表单字段的初始值
            form.setFieldsValue({
                jk_price: 0.01,
                jk_num: 1,
                jk_amount: ''
            })
        }
    }, [open, props, form])

    //提交
    const [addtijiao] = useJKaddtijiaoMutation()
    const [isSubmitting, setIsSubmitting] = useState(false)
    return (
        <>
            <Icon type='add' onClick={() => {setOpen(true)}} />
            <Modal
                open={open} 
                onCancel={() => {setOpen(false)}}
                width={1330}
                form={form}
                footer={null}
            >
                <Form
                    form={form}
                    className={classes.form}
                    labelCol={{ span: 4 }}
                    wrapperCol={{ span: 20 }}
                    initialValues={{
                        jk_date: props.dsbzd_date ? dayjs(props.dsbzd_date) : undefined,
                        jk_bm_id: props.dsbzd_bm_id ? props.dsbzd_bm_id : undefined,
                        jk_bm_name: props.dsbzd_bm_name ? props.dsbzd_bm_name : undefined,
                    }}
                >
                     <Row style={{width:"1280px"}}>
                       <Col span={4} className={classes.row_top_left} style={{borderTop:'3px solid #660099',borderLeft:'3px solid #660099'}}></Col>
                       <Col span={16} className={classes.row_top_middle} style={{color:'#660099',borderTop:'3px solid #660099'}}>借款单</Col>
                       <Col span={4} className={classes.row_top_right} style={{borderTop:'3px solid #660099',borderRight:'3px solid #660099'}}></Col>
                        {/* 第一行 */}
                       <Col span={2} className={classes.col_top_label} style={{borderLeft:'3px solid #660099',color:'#660099'}}>团队名称</Col>
                       <Col span={6}  className={classes.col_top_input}>
                           {props.dsbzd_name}
                       </Col>  
                       <Col span={2} className={classes.col_top_label} >团队客户类型</Col>
                       <Col span={6}  className={classes.col_top_input}>
                           {props.dsbzd_dscp_id && props.dsbzd_dscp_name && <div>{props.dsbzd_dscp_name}</div>}
                       </Col>  
                       <Col span={2}  className={classes.col_top_label} >团队客户</Col>
                       <Col span={6}  className={classes.col_right_input}  style={{borderRight:'3px solid #660099'}}>
                       {props.dsbzd_kh_id && props.dsbzd_kh_name && <div>{props.dsbzd_kh_name}</div>}
                       </Col> 
                       {/* 第二行 */}
                       <Col span={2}  className={classes.col_middle_label} style={{borderLeft:'3px solid #660099'}}><Asterisk color='red'/> 日期</Col>
                       <Col span={6}  className={classes.col_middle_input}>
                           <Form.Item name='jk_date' noStyle>
                               <DatePicker 
                                   placeholder='请选择日期' 
                                   onChange={(value) => {
                                       setInfo(prevState => ({ ...prevState, jk_date: value }))
                                   }}
                                   style={{ width: '100%' }}
                               />
                           </Form.Item>
                       </Col>
                       <Col span={2}  className={classes.col_middle_label}><Asterisk color='red'/>金额</Col>
                       <Col span={6}  className={classes.col_middle_input}>
                            <Form.Item name='jk_amount' noStyle>
                               <InputNumber 
                                   placeholder='请输入金额' 
                                   onChange={(value) => {
                                       setInfo(prevState => ({ ...prevState, jk_amount: value }))
                                   }}
                                   style={{ width: '100%' }}
                                   min={0.01}
                               />
                           </Form.Item>
                       </Col>
                       <Col span={2}  className={classes.col_middle_label}><Asterisk color='red'/> 部门</Col>
                       <Col span={6}  className={classes.col_middle_right_input}   style={{borderRight:'3px solid #660099'}}>
                           {props.dsbzd_bm_name}
                       </Col>
                       {/* 第三行 */}
                       <Col span={2}  className={classes.col_middle_label} style={{borderLeft:'3px solid #660099'}}><Asterisk color='red'/> 借款人</Col>
                       <Col span={6}  className={classes.col_middle_input}>
                            <ClientSelect
                                name='jk_kh_name'
                                placeholder='请选择借款客户'
                                onChange={(value,label) => {
                                    setInfo(prevState => ({ ...prevState, jk_kh_id: value, jk_kh_name: label }))
                                }}
                                style={{width: '230px'}}
                                formStyle={{marginBottom: 0,width: '100%'}}
                                qy_id={props.qy_id}
                                qy_name={props.qy_name}
                                yh_id={props.yh_id}
                                yh_name={props.yh_name}
                                defaultId={info.jk_kh_id}
                                wrapperCol={{span:24}}
                                clientAdd={true}
                            />
                       </Col>
                       <Col span={2}  className={classes.col_middle_label}><Asterisk color='red'/> 银行账户</Col>
                       <Col span={14}  className={classes.col_middle_right_input} style={{borderRight:'3px solid #660099'}}>
                            <ClientBankSelect
                                name='jk_khyhzh_name'
                                placeholder='请选择借款客户银行'
                                onChange={(value,label) => {
                                    setInfo(prevState => ({ ...prevState, jk_khyhzh_id: value, jk_khyhzh_name: label }))
                                }}
                                style={{ width: '100%' }}
                                formStyle={{marginBottom: 0,width: '100%'}}
                                wrapperCol={{span:24}}
                                qy_id={props.qy_id}
                                yh_id={props.yh_id}
                                defaultId={info.jk_khyhzh_id}
                                kh_id={info.jk_kh_id}
                            />
                       </Col>
                       {/* 第四行       */}
                       <Col span={2} className={classes.col_middle_label} style={{borderLeft:'3px solid #660099'}}>备注</Col>
                       <Col span={14}  className={classes.col_middle_input}>
                            <Form.Item name='jk_content' noStyle>
                               <OCRTextArea
                                   value={info.jk_content}
                                   onChange={(e) => {
                                       setInfo(prevState => ({ ...prevState, jk_content: e.target.value }))
                                   }}
                                   language="chi_sim"
                               />
                           </Form.Item>
                       </Col>    
                       <Col span={2} className={classes.col_middle_label}>转账记录</Col>
                       <Col span={6}  className={classes.col_middle_input} style={{borderRight:'3px solid #660099'}}>
                       </Col>                                   
                       {/* 第五行                             */}
                       <Col span={2} className={classes.col_middle_label} style={{borderLeft:'3px solid #660099'}}>附件</Col>
                       <Col span={14}  className={classes.col_bottom_input}>
                       <UploadPic
                               name='jk_image'
                               onChange={(e,f) => {
                                   setInfo(prevState => ({ ...prevState, jk_image_file: e, jk_image_name: f }))
                               }}
                               maxCount={5}
                               style={{ width: '100%' }}
                               formStyle={{marginBottom: 0,width: '100%'}}
                           />
                       </Col>                                   
                       <Col span={2}  className={classes.col_bottom_label}>编号/状态</Col>
                       <Col span={6}  className={classes.col_bottom_right} style={{borderRight:'3px solid #660099'}}></Col>   
                       {/* 第六行 */}
                       <Col span={24} className={classes.bottom_row}>
                            <LoanNodeAdd qy_id={props.qy_id} user_id={props.yh_id} yh_name={props.yh_name}/>
                       </Col>
                   </Row>  
                   <Row>
                        <Col span={24} style={{textAlign: 'right',paddingTop: '10px',display:'flex',justifyContent:'space-between'}}>
                            <DocumentRule/>
                            <Space size={20}>
                                <Icon 
                                    key='submit' 
                                    type='save' 
                                    onClick={() => {
                                        
                                        if(info.jk_amount === ''){  
                                            message.error('请输入金额');
                                            return;
                                        }
                                       
                                        if(info.jk_kh_id === ''){
                                            message.error('请选择客户');
                                            return;
                                        } 
                                        if(info.jk_date === ''){
                                            message.error('请选择日期');
                                            return;
                                        }
                                        if(info.jk_khyhzh_id === ''){
                                            message.error('请选择银行账户');
                                            return;
                                        }
                                        add({
                                            'jk_price': props.dsbzd_kh_id,
                                            'jk_uid': props.yh_id,
                                            'jk_uname': props.yh_name,
                                            'jk_content': info.jk_content,
                                            'jk_bzd_id': props.dsbzd_id,
                                            'jk_qy_id': props.qy_id,
                                            'jk_qy_name': props.qy_name,
                                            'jk_kh_id': info.jk_kh_id,
                                            'jk_kh_name': info.jk_kh_name,
                                            'jk_type_id': props.dsbzd_dscp_id,
                                            'jk_type_name': props.dsbzd_dscp_name,
                                            'jk_amount': info.jk_amount,
                                            'jk_bzd_xuhao': '',
                                            'jk_bzd_name': props.dsbzd_name,
                                            'jk_date': info.jk_date ? info.jk_date:props.dsbzd_date,
                                            'jk_bzd_date_end': props.dsbzd_date_end,
                                            'jk_num': props.dsbzd_kh_name, 
                                            'jk_name': info.jk_name,
                                            'jk_bzd_date': props.dsbzd_date,
                                            'jk_khyhzh_id': info.jk_khyhzh_id,
                                            'jk_khyhzh_name': info.jk_khyhzh_name,
                                            'jk_image_name': info.jk_image_name?info.jk_image_name:'',
                                            'jk_image_file': info.jk_image_file,
                                            'jk_bm_id': props.dsbzd_bm_id,
                                            'jk_bm_name': props.dsbzd_bm_name,
                                            'jk_state': '1',
                                            'jk_zflx': '应收',
                                            'spdd_sp_id': '14',
                                            'spdd_sp_name': '财务管理',
                                            'spdd_spgg_id': '21',
                                            'spdd_spgg_name': '借款单',
                                            'spdd_spgg_price': '0.1',
                                            'spdd_state': '支出'
                                        }).then(res => {
                                            if(res.data.Status==='success'){
                                                setOpen(false);
                                                message.success('新增成功');
                                                form.resetFields();  
                                            }else{
                                                message.error('新增失败！' + res.data.Message);
                                            }
                                        })     
                                    }}
                                />
                                <Icon 
                                    key='reset' 
                                    type='reset' 
                                    onClick={() => {
                                        form.resetFields()
                                        setInfo(prevState => ({ 
                                            ...prevState, 
                                            jk_price:'', 
                                            jk_num:1, 
                                            jk_amount:'', 
                                            jk_content:'',                             
                                            jk_type_id:'', 
                                            jk_type_name:'', 
                                            jk_kh_id:'', 
                                            jk_kh_name:'', 
                                            qy_id:props.qy_id, 
                                            qy_name:props.qy_name,
                                            jk_zflx: '应收'
                                        }))
                                        // 重置后重新设置表单字段的默认值
                                        form.setFieldsValue({
                                            jk_price: '',
                                            jk_num: 1,
                                            jk_amount: ''
                                        })
                                    }}
                                />
                                <Icon
                                    type='submit'
                                    title='提交'
                                    disabled={isSubmitting}
                                    style={isSubmitting ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
                                    onClick={() => {
                                        // 如果正在提交中，直接返回
                                        if (isSubmitting) {
                                            return;
                                        }
                                        
                                        // 先进行验证
                                        if(info.jk_amount === ''){
                                            message.error('请输入金额');
                                            return;
                                        }
                                       
                                        if(info.jk_kh_id === ''){
                                            message.error('请选择客户');
                                            return;
                                        }
                                        if(info.jk_khyhzh_id === ''){
                                            message.error('请选择银行账户');
                                            return;
                                        }                                       
                                        if(props.jk_bm_id === ''){
                                            message.error('请选择部门');
                                            return;
                                        }
                                        if(info.jk_date === ''){
                                            message.error('请选择日期');
                                            return;
                                        }
                                        
                                        // 验证通过后，设置提交状态
                                        setIsSubmitting(true);
                                        addtijiao({
                                            'jk_type_id': props.dsbzd_dscp_id,
                                            'jk_type_name': props.dsbzd_dscp_name,
                                            'jk_amount': info.jk_amount,
                                            'jk_qy_id': props.qy_id,
                                            'jk_qy_name': props.qy_name,
                                            'jk_num': props.dsbzd_kh_name,
                                            'jk_zflx': '应收',
                                            'jk_uid': props.yh_id,
                                            'jk_uname': props.yh_name,
                                            'jk_name': props.dsbzd_name,
                                            'jk_date': info.jk_date?info.jk_date:props.dsbzd_date,
                                            'jk_kh_id': info.jk_kh_id,
                                            'jk_kh_name': info.jk_kh_name,
                                            'jk_price': props.dsbzd_kh_id,
                                            'jk_content': info.jk_content,
                                            'jk_bzd_id': props.dsbzd_id,
                                            'jk_bzd_name': props.dsbzd_name,
                                            'jk_bzd_date': props.dsbzd_date,
                                            'jk_bzd_xuhao': '',
                                            'jk_bzd_date_end': props.dsbzd_date_end,
                                            'jk_khyhzh_id': info.jk_khyhzh_id,
                                            'jk_khyhzh_name': info.jk_khyhzh_name,
                                            'jk_bm_id': props.dsbzd_bm_id,
                                            'jk_bm_name': props.dsbzd_bm_name,
                                            'jk_image_name': info.jk_image_name?info.jk_image_name:'',
                                            'jk_image_file': info.jk_image_file?info.jk_image_file:'',
                                            'jk_state': '1'
                                        }).then(res => {
                                            if(res.data.Status==='success'){
                                                message.success('提交成功');
                                                setIsSubmitting(false);
                                                setOpen(false);
                                                
                                                form.resetFields();  
                                            }else{
                                                message.error('提交失败！' + res.data.Message);
                                            }
                                        })     
                                    }}
                                /> 
                            </Space> 
                        </Col>
                    </Row>
                </Form>
            </Modal>

        </>
    )
}

export default LoanAddReportEdit